import { translate } from '~l10n/client';

import axios from '../../localAxios';
import { extractSocNumber } from '../../utils/extractSocNumber';
import { copyURL } from '../url';

export interface CopyQuizBySocParams {
  parentId: number;
  socNumber: string;
  newName: string;
  originalName: string;
}

export interface ResponseBody {
  date: string;
  soc: string;
  name: string;
  parentId: number;
  id: number;
  sharable: boolean;
  standard: string;
  version: number;
}

export async function copyQuizBySoc({
  parentId,
  socNumber,
  newName,
  originalName,
}: CopyQuizBySocParams) {
  // Validate and extract the SOC number using the new format
  const validatedSocNumber = extractSocNumber(socNumber);

  // If name is null/undefined/only contains whitespace, use the original name + (Copy)
  if (!newName || !newName.match(/\S/)) {
    newName = `${originalName} ${translate('(Copy)')}`;
  }

  const url = copyURL();
  const response = await axios.post<ResponseBody>(url.href, {
    parentId: parentId,
    socNumber: validatedSocNumber,
    name: newName,
  });
  return response.data;
}
